<template>
  <div>
    <div v-if="fetching" class="bg-grey-light text-center py-6">
      <h3>
        <i class="fa fa-refresh fa-spin" />
        Fetching Addons...
      </h3>
    </div>
    <div v-if="!fetching && filterdAddonItems.length === 0" class="bg-grey-light text-center py-6">
      <h3>
        No addons found
      </h3>
    </div>
    <accordion v-for="(addon, index) in filterdAddonItems" :title="addon.addon_name" :key="index" :show="show">
      <div
        v-if="!id"
        slot="accordion-header"
        class="flex flex-col md:flex-row items-center self-end md:self-center p-4 pt-0 md:py-0 md:pl-0"
      >
        <p class="text-black mb-1 md:mb-0 mr-2">Available</p>
        <pt-form-switch
          :disabled="processing"
          :value="isAddonsAvailable(addon.items)"
          on-label="Yes"
          off-label="No"
          @input="changeAllStatus(addon.items)"
        />
      </div>
      <div
        v-for="addon in addon.items"
        :key="addon.id"
        class="px-4 md:px-10 py-4 border-b border-solid w-full flex justify-between items-center"
      >
        <div class="flex flex-col">
          <p class="leading-normal text-black font-bold text-lg mb-2">{{ addon.item_name }}</p>
          <div class="flex w-1/3">
            <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka mr-1" />
            <span v-else> रू </span>
            <p class="text-md">{{ addon.price }}</p>
          </div>
        </div>

        <div class="flex flex-col items-center">
          <p class="md:mr-2 mb-1">Available</p>
          <pt-form-switch
            v-if="!id"
            ref="'acceptSwitch'+item.id"
            :disabled="processing"
            v-model="addon.is_visible"
            size="medium"
            on-label="Yes"
            off-label="No"
            @input="changeStatus(addon)"
          />
        </div>
      </div>
    </accordion>
  </div>
</template>

<script>
import apiRequest from '@src/utils/apiRequest';
import Accordion from '@components/custom/Accordion';
import { PtFormInput, PtFormGroup, PtFormSwitch } from '@pathao/ui-components/esm/FormComponents';
import { RESTO_ADDONS, RESTO_ITEM_ADDONS, RESTO_ADDONS_UPDATE } from '@src/config/apiEndpoints';
import { mapGetters } from 'vuex';
import isBDPhoneNumber from '@src/utils/isBdNumber';

export default {
  components: {
    Accordion,
    PtFormInput,
    PtFormGroup,
    PtFormSwitch,
  },
  props: {
    id: {
      type: String,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      addons: [],
      available: true,
      fetching: false,
      processing: false,
      activeBtn: 'items',
    };
  },
  computed: {
    ...mapGetters({
      userName: 'auth/userName',
    }),
    filterdAddonItems() {
      return this.addons.filter(addon => {
        let re = new RegExp(this.search.replace(/\\/g, '\\\\'), 'i');
        if (addon.addon_name.match(re)) {
          return true;
        } else {
          let foundItem = addon.items.filter(subItem => {
            return subItem.item_name.match(re);
          });
          if (foundItem.length > 0) {
            return true;
          }
        }
        return false;
      });
    },
  },
  created() {
    if (this.id) {
      this.getItemsAddons();
    } else {
      this.getAddons();
    }
  },
  methods: {
    isBDPhoneNumber,
    isAddonsAvailable(items) {
      return items.some(item => item.is_visible);
    },
    changeAllStatus(items) {
      const availability = this.isAddonsAvailable(items);
      const ids = items.map(item => item.id);
      let payload = {
        url: RESTO_ADDONS_UPDATE,
        method: 'PATCH',
        data: {
          is_visible: !availability,
          addon_ids: ids,
        },
      };
      this.processing = true;
      apiRequest(payload)
        .then(response => {
          this.processing = false;
          this.$notification.success(response.data.message);
          this.getAddons();
        })
        .catch(() => {
          this.processing = false;
          this.$notification.error('Addons changed failed');
        });
    },
    changeStatus(addon) {
      let payload = {
        url: RESTO_ADDONS_UPDATE,
        method: 'PATCH',
        data: {
          is_visible: addon.is_visible,
          addon_ids: [addon.id],
        },
      };
      this.processing = true;
      apiRequest(payload)
        .then(response => {
          this.$notification.success(response.data.message);
          this.processing = false;
        })
        .catch(() => {
          this.processing = false;
          this.$notification.error('Addons changed failed');
        });
    },
    getAddons() {
      let payload = {
        url: RESTO_ADDONS,
        method: 'GET',
      };
      this.fetching = true;
      apiRequest(payload)
        .then(response => {
          this.addons = response.data.addons;
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
    getItemsAddons() {
      let payload = {
        url: RESTO_ITEM_ADDONS,
        method: 'GET',
        params: {
          item_id: this.id,
        },
      };
      this.fetching = true;
      apiRequest(payload)
        .then(response => {
          this.addons = response.data.addons;
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
